import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import PostCard from "@/components/PostCard";
import { useAuth } from "@/context/AuthContext";
import { startCheckout } from "@/lib/checkout";

export default function Feed() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/posts/feed").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  const onCheckout = (post) => {
    if (post.visibility === "ppv") startCheckout({ kind: "ppv", resource_id: post.id });
    else startCheckout({ kind: "subscription", resource_id: post.creator.id });
  };

  return (
    <div className="max-w-2xl mx-auto px-5 py-10" data-testid="feed-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="mb-8">
        <h1 className="font-display text-5xl md:text-6xl leading-none">Your <span className="italic text-primary">feed</span></h1>
        <p className="text-muted-foreground mt-2">Fresh drops from creators you follow & subscribe to.</p>
      </motion.div>

      {posts === null ? (
        <p className="py-16 text-center text-muted-foreground">Loading…</p>
      ) : posts.length ? (
        <div className="flex flex-col gap-6">
          {posts.map((p, i) => <PostCard key={p.id} post={p} index={i} onCheckout={onCheckout} />)}
        </div>
      ) : (
        <div className="py-24 text-center" data-testid="feed-empty">
          <p className="font-display text-4xl mb-3">Quiet in here…</p>
          <p className="text-muted-foreground mb-6">Follow creators to fill your feed with fantasy.</p>
          <button data-testid="feed-explore-btn" onClick={() => navigate("/explore")}
            className="px-8 py-4 bg-primary text-primary-foreground font-accent font-bold uppercase tracking-widest text-sm transition-transform active:scale-95 hover:bg-[#e6004c]">
            Explore creators
          </button>
        </div>
      )}
    </div>
  );
}
